import { VehicleOrderViewModel } from '@ail/orders-api'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getVehicleOrderStatus } from '../../../helpers/Orders'
import { useAuth } from '../../../hooks/useAuth'
import OrderDetails from '../../GeneralContracts/Formatters/OrderDetails'

export function VehicleOrderDetails(props: { vehicleOrder: VehicleOrderViewModel; show: boolean }) {
  const [showOrderDetails, setShowOrderDetails] = useState(false)
  const { user } = useAuth()
  const { t } = useTranslation('common')

  useEffect(() => {
    setShowOrderDetails(props.show)
  }, [props.show])

  return (
    <div className="detailContentArea" style={{ zIndex: 1 }}>
      <div className="detailTitle withStatus">
        <span>
          <i className="icon-garageOut" /> <span>{t('VEHICLE_ORDER_HISTORY')}</span>
        </span>
        <div className="statusIcon">
          <div
            className={`statusArea orderDetailToggle ${getVehicleOrderStatus(props.vehicleOrder)}`}
            onClick={() => {
              setShowOrderDetails(!showOrderDetails)
            }}
          >
            {t(getVehicleOrderStatus(props.vehicleOrder).toUpperCase())}
            <i className={`${showOrderDetails ? 'icon-up' : 'icon-bottom'}`} />
          </div>
        </div>
      </div>
      {showOrderDetails && (
        <OrderDetails vehicleOrderData={props.vehicleOrder} isInternalUser={!!user?.isInternalUser} altLayout={true} />
      )}
    </div>
  )
}
